import React from "react";
import { Container, Row, Col, Button, Card, Form } from "react-bootstrap";
const logoSrc = "/logo2.png";
function Home() {
  return (
    <>
    <header className="hero-section">
        <Container className="py-5">
          <Row className="align-items-center gy-4">
            <Col md={7}>
              <h1 className="hero-title">
                Machine Vision &amp; IIoT for smarter factories —
                <span className="hero-accent"> engineered by Innoish.</span>
              </h1>

              {/* <p className="hero-lead text-muted">
                We build synchronized digital twins, fast simulation pipelines, and industrial-grade machine vision
                systems so factories operate smarter, safer, and more efficiently.
              </p> */}

              <p className="hero-sub">
                We deliver industrial machine vision and IIoT solutions that make factories smarter, safer, and more efficient.
              </p>

              <div className="d-flex flex-wrap gap-3 mt-4">
                <Button href="#demo" className="btn-primary-gradient">Request a Demo</Button>
                <Button variant="outline-secondary" href="#solutions">Explore Solutions</Button>
              </div>

              <div className="d-flex gap-4 mt-4 flex-wrap text-muted small">
                {/* <div className="d-flex align-items-center gap-2"><span className="dot bg-purple" /> Industry-grade deployments</div>
                <div className="d-flex align-items-center gap-2"><span className="dot bg-purple" /> Edge &amp; cloud integration</div>
                <div className="d-flex align-items-center gap-2"><span className="dot bg-purple" /> Customizable to your workflow</div> */}
                <div className="d-flex align-items-center gap-2"><span className="dot bg-purple" /> Industry-grade deployments — production-ready and hardened for factory environments</div>
                <div className="d-flex align-items-center gap-2"><span className="dot bg-purple" /> Rapid proof-of-concept &amp; pilots</div>
                <div className="d-flex align-items-center gap-2"><span className="dot bg-purple" /> Customizable to your workflow</div>
              </div>
            </Col>

            <Col md={5} className="d-flex justify-content-center">
              <div className="mockup-card" role="img" aria-label="Machine vision and IIoT dashboard preview">
                <div className="mockup-surface">
                  <div className="mockup-inner">
                    <img src={logoSrc} alt="Innoish" style={{ width: 110, display: "block", margin: "0 auto" }} />
                    <h3 className="mockup-title">Machine Vision & IIoT Dashboard</h3>
                    <p className="mockup-sub">Real-time monitoring · analytics · edge insights</p>
                  </div>
                </div>

                <div className="mockup-grid">
                  <div className="item">
                    <strong>Live Sync</strong>
                    <div className="small">Sensors → Twin</div>
                  </div>
                  <div className="item">
                    <strong>What-if Tests</strong>
                    <div className="small">Plan &amp; validate</div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      {/* Solutions */}
      <section id="solutions" className="py-5">
        <Container>
          <h3 className="section-title">What we provide</h3>
          <p className="text-muted mb-4">High-impact products and services across machine vision and Industrial IoT (IIoT).</p>

          <Row xs={1} md={3} className="g-4">
            <Col>
              <Card className="h-100 service-card">
                <div className="service-icon">IMV</div>
                <Card.Body>
                  <Card.Title>Industrial Machine Vision Solutions</Card.Title>
                  <Card.Text className="text-muted small">
                    Robust vision systems for detection, classification and guidance — tuned for industrial environments.
                    <p></p>
                    <ul>
                      <li>Parts Inspection</li>
                      <li>Object Presence on defined locations</li>
                      <li>Vision-based Quality Control on Assembly Lines</li>
                      <li>Protocol Violation Detection for Safety and Compliance</li>
                    </ul>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            {/* <Col>
              <Card className="h-100 service-card">
                <div className="service-icon">MV</div>
                <Card.Body>
                  <Card.Title>Machine Vision Solutions</Card.Title>
                  <Card.Text className="text-muted small">
                    Robust vision systems for detection, classification and guidance — tuned for industrial environments.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col> */}

            <Col>
              <Card className="h-100 service-card">
                <div className="service-icon">PM</div>
                <Card.Body>
                  <Card.Title>Predictive Maintenance</Card.Title>
                  <Card.Text className="text-muted small">
                    IIoT-enabled monitoring and analytics to predict failures, reduce downtime and optimise maintenance schedules:
                    <p></p>
                    <ul>
                      <li>Sensors integration and data collection</li>
                      <li>Data analysis and anomaly detection</li>
                      <li>Predictive analytics and failure forecasting</li>
                      <li>Maintenance scheduling optimization</li>
                      <li>Real-time monitoring and alerts</li>
                    </ul>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col>
              <Card className="h-100 service-card">
                <div className="service-icon">AE</div>
                <Card.Body>
                  <Card.Title>Automation &amp; Machine Engineering</Card.Title>
                  <Card.Text className="text-muted small">
                    Turnkey engineering for special-purpose machines and factory automation:
                    <p></p>
                    <ul>
                      <li>Hardware selection, BOM & ECAD drawings</li>
                      <li>PLC programming & HMI integration</li>
                      <li>Commissioning, validation & on-site support</li>
                      <li>High-level control software for special machines and custom-equipment</li>
                    </ul>
                   
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className="h-100 service-card">
                <div className="service-icon">SPM</div>
                <Card.Body>
                  <Card.Title>Special-Purpose Machines</Card.Title>
                  <Card.Text className="text-muted small">
                    Comprehensive lifecycle and on-site support for special-purpose machines, including maintenance, troubleshooting, retrofits and spare-parts support.
                    <p></p>
                    <ul>
                      <li>Rebar cutting machines</li>
                      <li>Laser cutting machines</li>
                      <li>Laser welding systems</li>
                    </ul>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className="h-100 service-card">
                <div className="service-icon">SF</div>
                <Card.Body>
                  <Card.Title>Smart Factories</Card.Title>
                  <Card.Text className="text-muted small">
                    Integrated IIoT platforms, automation and analytics to deliver efficient, connected and scalable manufacturing.
                    <p></p>
                    <ul>
                      <li>Production data collection from machines</li>
                      <li>Operator engagement and shift metrics</li>
                      <li>Machine performance and utilization statistics</li>
                    </ul>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>


            <Col>
              <Card className="h-100 service-card">
                <div className="service-icon">PP</div>
                <Card.Body>
                  <Card.Title>Real-time Pallet Presence</Card.Title>
                  <Card.Text className="text-muted small">
                    Real-time detection of pallet presence inside ASRS racking to accurately know which bins are occupied.
                    An IIoT-based solution to eliminate inventory loss, mismatches and unknown pallets at bin locations — improving inventory accuracy and operational throughput.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className="h-100 service-card">
                <div className="service-icon">AT</div>
                <Card.Body>
                  <Card.Title>Asset Tracking &amp; Fleet Monitoring</Card.Title>
                  <Card.Text className="text-muted small">
                    Location-aware asset tracking and fleet telematics to improve utilization and traceability across operations.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            
          </Row>
        </Container>
      </section>

      {/* About + Contact */}
      <section id="about" className="py-5 bg-light">
        <Container>
          <Row className="gy-4">
            <Col md={7}>
              <h4>Why Innoish?</h4>
              <p className="text-muted">We combine deep industrial domain knowledge, machine-vision expertise and IIoT engineering to deliver production-ready solutions.</p>

              <ul className="text-muted">
                <li><strong>End-to-end delivery</strong> — From rapid proof-of-concept to plant roll-out and lifecycle support.</li>
                <li><strong>Industrial reliability</strong> — Hardened for real factory conditions and continuous operation.</li>
                <li><strong>Customised solutions</strong> — Tailored to solve specific industry problems and workflows.</li>
              </ul>
            </Col>

            <Col md={5}>
              <Card className="contact-card p-3">
                <Card.Body>
                  <Card.Title>Quick contact</Card.Title>
                  <Card.Text className="text-muted small">Tell us about your requirement and we'll suggest the right solution.</Card.Text>
                  <Form onSubmit={(e) => { e.preventDefault(); alert("Thanks — demo request sent (placeholder)."); }}>
                    <Form.Group className="mb-2">
                      <Form.Control placeholder="Name" required />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Control placeholder="Company" />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Control type="email" placeholder="Email" required />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Control as="textarea" rows={3} placeholder="Short requirement description" />
                    </Form.Group>

                    <div className="d-flex gap-2">
                      <Button type="submit" className="btn-primary-gradient">Send Enquiry</Button>
                      {/* <Button variant="outline-secondary" href="#demo">Schedule Meeting</Button> */}
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA */}
      {/* <section id="demo" className="py-4">
        <Container>
          <div className="cta d-flex align-items-center justify-content-between p-4 rounded-3">
            <div>
              <h5 className="mb-1">Ready to modernize your factory with Industrial Machine Vision &amp; IIoT?</h5>
              <div className="text small">Talk to our engineers and see a tailored demo.</div>
            </div>
            <div className="d-flex gap-2">
              <Button href="#contact" className="btn-light-cta">Request Demo</Button>
              <Button variant="outline-light" className="text-white border-white">Contact Sales</Button>
            </div>
          </div>
        </Container>
      </section> */}
</>
  );
}

export default Home;